import { Injectable } from '@angular/core';
import { Statistics } from '@models/statistics.interface';

@Injectable({
  providedIn: 'root',
})
export class CompilerStatisticsService {
  constructor() {}
  public get getCompilerStatistics(): Statistics {
    return this.compilerStatistics();
  }

  private compilerStatistics(): Statistics {
    return [
      {
        key: 'all_created_games',
        title: 'Total Games Created',
        icon: 'game_base',
      },
      {
        key: 'ready_for_scheduling',
        title: 'Games Ready for Scheduling',
        icon: 'game_ready',
      },
      {
        key: 'created_standard_games',
        title: 'Standard Games Created',
        icon: 'game_standard',
      },
      {
        key: 'created_spcialty_games',
        title: 'Specialty Games Created',
        icon: 'game_special',
      },
    //   {
    //     title: 'Private Games Created',
    //     icon: 'game_private',
    //   },
    ];
  }
}
